var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlay = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 19,
  height: 22,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M17.128 7.84 4.25.4A2.4 2.4 0 0 0 3.035.063 2.535 2.535 0 0 0 .5 2.598v15.967a2.497 2.497 0 0 0 3.825 2.115l12.893-8.145a2.738 2.738 0 0 0-.09-4.695"
})));
export default SvgPlay;